/**
 * URL Unlocking Constants
 */

export const i18nKeys = {
  TITLE: 'systemSettings.urlUnlocking.title',
  DESCRIPTION: 'systemSettings.urlUnlocking.description',
  EXPLANATION: {
    TITLE: 'systemSettings.urlUnlocking.explanation.title',
    PRIMARY: 'systemSettings.urlUnlocking.explanation.primary',
    SECONDARY: 'systemSettings.urlUnlocking.explanation.secondary',
    TERTIARY: 'systemSettings.urlUnlocking.explanation.tertiary'
  },
  FORM: {
    MODE_LABEL: 'systemSettings.urlUnlocking.form.modeLabel',
    MODE_EASY: 'systemSettings.urlUnlocking.form.modeEasy',
    MODE_ADVANCED: 'systemSettings.urlUnlocking.form.modeAdvanced',
    TARGET_TYPE_LABEL: 'systemSettings.urlUnlocking.form.targetTypeLabel',
    TARGET_TYPE_PLACEHOLDER: 'systemSettings.urlUnlocking.form.targetTypePlaceholder',
    TARGET_PRIMARY: 'systemSettings.urlUnlocking.form.targetPrimary',
    TARGET_SECONDARY: 'systemSettings.urlUnlocking.form.targetSecondary',
    TARGET_TERTIARY: 'systemSettings.urlUnlocking.form.targetTertiary',
    FULL_URL_LABEL: 'systemSettings.urlUnlocking.form.fullUrlLabel',
    FULL_URL_PLACEHOLDER: 'systemSettings.urlUnlocking.form.fullUrlPlaceholder',
    PRIMARY_PATH_LABEL: 'systemSettings.urlUnlocking.form.primaryPathLabel',
    PRIMARY_PATH_PLACEHOLDER: 'systemSettings.urlUnlocking.form.primaryPathPlaceholder',
    SECONDARY_PATH_LABEL: 'systemSettings.urlUnlocking.form.secondaryPathLabel',
    SECONDARY_PATH_PLACEHOLDER: 'systemSettings.urlUnlocking.form.secondaryPathPlaceholder',
    TERTIARY_PATH_LABEL: 'systemSettings.urlUnlocking.form.tertiaryPathLabel',
    TERTIARY_PATH_PLACEHOLDER: 'systemSettings.urlUnlocking.form.tertiaryPathPlaceholder',
    SEARCH_BUTTON: 'systemSettings.urlUnlocking.form.searchButton',
    CLEAR_BUTTON: 'systemSettings.urlUnlocking.form.clearButton',
    VALIDATION_INVALID_URL: 'systemSettings.urlUnlocking.form.validationInvalidUrl',
    VALIDATION_INVALID_DOMAIN: 'systemSettings.urlUnlocking.form.validationInvalidDomain',
    VALIDATION_MISSING_TARGET_TYPE: 'systemSettings.urlUnlocking.form.validationMissingTargetType',
    VALIDATION_MISSING_PRIMARY: 'systemSettings.urlUnlocking.form.validationMissingPrimary',
    VALIDATION_MISSING_SECONDARY: 'systemSettings.urlUnlocking.form.validationMissingSecondary',
    VALIDATION_MISSING_TERTIARY: 'systemSettings.urlUnlocking.form.validationMissingTertiary'
  },
  RESULTS: {
    TITLE: 'systemSettings.urlUnlocking.results.title',
    NO_DATA: 'systemSettings.urlUnlocking.results.noData',
    ID: 'systemSettings.urlUnlocking.results.id',
    URL_TYPE: 'systemSettings.urlUnlocking.results.urlType',
    URL_PATH: 'systemSettings.urlUnlocking.results.urlPath',
    LINKED_ENTITIES: 'systemSettings.urlUnlocking.results.linkedEntities',
    ORGANIZATION: 'systemSettings.urlUnlocking.results.organization',
    EVENT: 'systemSettings.urlUnlocking.results.event',
    CAMPAIGN: 'systemSettings.urlUnlocking.results.campaign',
    FUNDRAISER: 'systemSettings.urlUnlocking.results.fundraiser',
    TEAM: 'systemSettings.urlUnlocking.results.team',
    SUPERTEAM: 'systemSettings.urlUnlocking.results.superteam',
    SERIES: 'systemSettings.urlUnlocking.results.series',
    DELETE_BUTTON: 'systemSettings.urlUnlocking.results.deleteButton'
  },
  DELETE_MODAL: {
    TITLE: 'systemSettings.urlUnlocking.deleteModal.title',
    WARNING: 'systemSettings.urlUnlocking.deleteModal.warning',
    CHECKBOX_LABEL: 'systemSettings.urlUnlocking.deleteModal.checkboxLabel',
    CONFIRM_BUTTON: 'systemSettings.urlUnlocking.deleteModal.confirmButton',
    CANCEL_BUTTON: 'systemSettings.urlUnlocking.deleteModal.cancelButton',
    SUCCESS: 'systemSettings.urlUnlocking.deleteModal.success',
    ERROR: 'systemSettings.urlUnlocking.deleteModal.error'
  },
  ERRORS: {
    PUBLIC_FETCH_FAILED: 'systemSettings.urlUnlocking.errors.publicFetchFailed',
    PAGE_URL_FETCH_FAILED: 'systemSettings.urlUnlocking.errors.pageUrlFetchFailed',
    MISSING_REQUIRED_IDS: 'systemSettings.urlUnlocking.errors.missingRequiredIds',
    DELETE_FAILED: 'systemSettings.urlUnlocking.errors.deleteFailed'
  }
};

/**
 * Valid domain for URL validation
 * Supports production and non-production environments:
 * - grassrootz.com (production)
 * - dev.grassrootz.com (development)
 * - test.grassrootz.com (testing)
 * - staging.grassrootz.com (staging)
 * - uat.grassrootz.com (UAT)
 */
export const VALID_DOMAIN = 'grassrootz.com';

/**
 * Environment subdomains to filter out when extracting primary subdomain
 */
export const ENV_SUBDOMAINS = ['dev', 'test', 'staging', 'uat'];

/**
 * URL type display names - maps Collection to Superteam
 */
export const URL_TYPE_DISPLAY_NAMES: Record<number, string> = {
  1: 'Organization',
  2: 'Campaign',
  3: 'Event',
  4: 'Fundraiser',
  5: 'Team',
  6: 'Superteam', // Collection → Superteam
  7: 'Series'
};
